import { useMemo } from 'react';

import { useLocation } from '@trello/router';

import { ViewType } from 'app/src/components/ViewsGenerics';
import { pathnameToRouteContext } from 'app/src/router/pathnameToRouteContext';

export const routeToNameMapping: { [key: string]: ViewType } = {
  'calendar-view': ViewType.CALENDAR,
  board: ViewType.BOARD,
  table: ViewType.TABLE,
  timeline: ViewType.TIMELINE,
  dashboard: ViewType.DASHBOARD,
  map: ViewType.MAP,
};

export const useCurrentView = (): ViewType | null => {
  const location = useLocation();
  const route = useMemo(
    () => pathnameToRouteContext(`${location.pathname}${location.search}`),
    [location.pathname, location.search],
  );

  const path = route.routePath;
  const pathArgs = path.split('/');
  const currentView =
    (pathArgs.length >= 5 && pathArgs[4]?.split('?')[0]) || 'board';
  return routeToNameMapping[currentView] ?? null;
};
